import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {Nfo} from '@app/titles/models/lien';

interface Response extends BackendResponse {
  nfo: Nfo;
}

export function useNfo(id: number | undefined) {
  return useQuery({
    queryKey: ['nfo', id],
    enabled: id !== undefined,
    queryFn: () => fetchNfo({id}),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

function fetchNfo({id}: {id: number | undefined}) {
  return apiClient
    .get<Response>(`liens/${id}/nfo`)
    .then(response => response.data);
}
